import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { useTable, usePagination, useSortBy, useRowSelect } from "react-table";

const Styles = styled.div`
  padding: 1rem;
  overflow-x: auto;
  margin-bottom: 50px;
  width: 100%;
  table {
    border-collapse: separate;
    border-spacing: 0;
    border: 2px solid #f5f5ff;
    width: 100%;
    height: 50px;

    thead {
      background-color: #f5f5ff;
    }
    td {
      border: 1px rgb(201, 204, 216);
      border-style: solid none solid none;
      padding: 10px;
    }
    tr {
      height: 60px;
      width: 1086px;
      left: 309px;
      top: 350px;
      border-radius: 5px;
    }
    // tr:hover{
    //   background:#f5f5ff;
    // }
    th {
      color: #ffffff;
    }
    th:first-child {
      border-top-left-radius: 10px;
    }

    th:last-child {
      border-top-right-radius: 10px;
    }
    span {
      margin: 5px;
    }
    th,
    td {
      border-bottom: 1px solid #f5f5ff;
      border-right: 0px solid black;
      padding: 8px;
      white-space: nowrap;
      text-align: start;
      :last-child {
        border-right: 0;
        text-align: center;
      }
    }
  }
  .pagination {
    height: 50px;
    padding: 0.2rem 0;
    position: absolute;
    align-items: baseline;
    right: 14px;
    justify-content: end;
    bottom: 5px;
    button,
    select {
      margin: 2px;
    }
    button {
      border: 1px solid #999999;
      background-color: #dcdcdc; // #ffffff;
      color: #666666;
      margin: 16px 10px;
    }

    button:hover {
      border: 1px solid #999999; //#0099cc;
    }

    button:disabled,
    button[disabled] {
      border: 1px solid #999999;
      background-color: #ffffff; //#cccccc;
    }
  }

  @media (max-width: 1536px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: 15px !important;
      // bottom: 15px !important;
    }
  }

  @media (max-width: 1280px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: 15px !important;
    }
  }
  @media (max-width: 1098px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: 14px !important ;
      select {
        margin: 2px 5px 0px 0px;
      }
    }
  }

  @media (max-width: 768px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: -1px !important;
      select {
        margin: 2px 20px 0px 0px;
      }
    }
  }
  .double-screen-pagination {
    height: 50px;
    padding: 2rem 0 0 0;
    position: absolute;
    align-items: baseline;
    right: 15px;
    justify-content: end;
    button,
    select {
      margin: 2px;
    }
    button {
      border: 1px solid #999999;
      background-color: #dcdcdc; // #ffffff;
      color: #666666;
      margin: 16px 10px;
    }

    button:hover {
      border: 1px solid #999999; //#0099cc;
    }

    button:disabled,
    button[disabled] {
      border: 1px solid #999999;
      background-color: #ffffff; //#cccccc;
    }
  }
  @media (max-width: 1536px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 0 !important;
    }
  }

  @media (max-width: 1280px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 15px;
    }
  }
  @media (max-width: 1098px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 0 !important ;
    }
  }

  @media (max-width: 768px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 0;
    }
  }
`;

var tempIndexValue = 0;
var signTypeTemp;

var tempTab = localStorage.getItem("navTemp");
var testOff = false;
var temTableKey = "";
const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    const isChecked =
      rest.row && rest.row.original && rest.row.original.isSelected;

    return (
      <>
        <input
          type="checkbox"
          ref={resolvedRef}
          {...rest}
          checked={isChecked}
        />
      </>
    );
  }
);

function Table({
  totalCount,
  columns,
  data,
  pagination,
  defaultFilterMethod,
  paginationDoubleScreen,
  activepageCount,
  paginationCountHanlde,
  scroll,
  scrollRef,
  tigger,
  tabTemp,
  tempKey,
  filterAction,
  tempBtnType,
  tempSearchTrigger,
  userfilterAction,
  checkBox,
  onRowCheckboxChange,
  // onHeaderCheckboxChange,
}) {
  // Use the state and functions returned from useTable to build your UI
  const moveScroll = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    gotoPage,
    pageOptions,
    nextPage,
    pageCount,
    previousPage,
    setPageSize,
    stateReducer,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      sortTypes: {
        alphanumeric: (row1, row2, columnName) => {
          const rowOneColumn = row1.values[columnName];
          const rowTwoColumn = row2.values[columnName];
          if (rowOneColumn == null) {
            return 1;
          } else if (isNaN(rowOneColumn)) {
            return rowOneColumn?.toUpperCase() > rowTwoColumn?.toUpperCase()
              ? 1
              : -1;
          }
          return Number(rowOneColumn) > Number(rowTwoColumn) ? 1 : -1;
        },
      },
      columns,
      data,

      // initialState: { pageIndex: activepageCount ? activepageCount : 0  },
      initialState: {
        pageIndex:
          tigger == "init" && tempKey
            ? 0
            : tigger == "amhitted" || tabTemp == "active"
            ? 0
            : tigger == "view" && userfilterAction == 1
            ? 0
            : tigger == "view" && userfilterAction == 0
            ? tempIndexValue
            : // ? tempIndexValue
            tempIndexValue &&
              signTypeTemp === "front" &&
              tigger == "view" &&
              userfilterAction == 0
            ? tempIndexValue + 1
            : tempIndexValue &&
              signTypeTemp === "back" &&
              tigger == "view" &&
              userfilterAction == 0
            ? tempIndexValue - 1
            : 0,
      },
      defaultFilterMethod,
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        ...(checkBox
          ? [
              {
                id: "selection",
                Header: ({ getToggleAllRowsSelectedProps }) => (
                  <IndeterminateCheckbox
                    {...getToggleAllRowsSelectedProps()}
                    // onChange={(e)=>onHeaderCheckboxChange(e)}
                    style={{ margin: "5px 0px 2px 15px", cursor: "pointer" }}
                  />
                ),
                Cell: ({ row }) => (
                  <IndeterminateCheckbox
                     row ={row}
                    {...row.getToggleRowSelectedProps()}
                    onChange={() => onRowCheckboxChange(row)}
                    style={{ margin: "5px 0px 2px 15px", cursor: "pointer" }}
                  />
                ),
              },
            ]
          : []),
        ...columns,
      ]);
    }
  );
  const [typeMom, setTypeMom] = useState("");
  const firstPageRows = rows.slice(0, 10);
  const [tableSrollTrigger, setTableScrollTigger] = useState(false);
  // Render the UI for your table

  useEffect(() => {
    paginationCountHanlde && paginationCountHanlde(pageIndex);
    setTypeMom(signTypeTemp);
    testOff = true;
    // temTableKey = tempKey;
  }, [pageIndex && tempIndexValue, tigger, userfilterAction]);

  const paginationMomentHandle = (signType) => {
    if (signType == "front") {
      // tigger= true
      tigger = "init";
      nextPage();
      tempIndexValue = pageIndex + 1;
      signTypeTemp = signType;
      setTypeMom(signType);
    } else {
      // tigger= true
      tigger = "init";
      previousPage();
      tempIndexValue = pageIndex - 1;
      signTypeTemp = signType;
      setTypeMom(signType);
    }
    // pageIndexTriggerSwtich = false;
    moveScroll();
  };

  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, idx) =>
                !column.hideHeader ? (
                  <th
                    {...column.getHeaderProps(
                      column.getSortByToggleProps({ title: undefined })
                    )}
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " ↓"
                          : " ↑"
                        : ""}
                    </span>
                  </th>
                ) : (
                  <></>
                )
              )}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps({
                        style: {
                          minWidth: cell.column.minWidth,
                          width: cell.column.width,
                          fontSize:
                            cell.row.values.serialNumber === "Total Tax Amount"
                              ? "18px"
                              : "",
                          color:
                            cell.row.values.serialNumber === "Total Tax Amount"
                              ? "#262626"
                              : "",
                        },
                      })}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        {tableSrollTrigger || (pageIndex > 0 && !canNextPage)
          ? window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
          : null}
      </table>
      {/*   
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      {pagination ? (
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
            width: "94%",
          }}
          className={
            paginationDoubleScreen ? "double-screen-pagination" : "pagination"
          }
        >
          {totalCount && (
            <div style={{ fontWeight: "500" }}>
              {/* Showing {page.length} of {swapStationCount} Records */}
              Showing {pageIndex * pageSize + 1}-
              {Math.min((pageIndex + 1) * pageSize, totalCount)} of {totalCount}{" "}
              Records
            </div>
          )}
          <div>
            <button
              //  onClick={() => {
              //   previousPage();
              //   moveScroll();
              // }}

              onClick={() => {
                paginationMomentHandle("back");
                setTableScrollTigger(() => true);
              }}
              disabled={!canPreviousPage}
            >
              {"<"}
            </button>
            {""}
            <span style={{ margin: "21px 0px" }}>
              Page <strong>{pageIndex + 1}</strong> of{" "}
              {pageOptions.length === 0 ? 1 : pageOptions.length}{" "}
            </span>
            <button
              onClick={() => {
                setTableScrollTigger(() => false);
                paginationMomentHandle("front");
              }}
              // onClick={() =>{
              //    nextPage();
              //    moveScroll();
              //    }}
              disabled={!canNextPage}
            >
              {">"}
            </button>{" "}
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                moveScroll();
              }}
            >
              {[10, 20, 30, 40, 50].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
function filterCaseInsensitive(filter, row) {
  const id = filter.pivotId || filter.id;
  return row[id] !== undefined
    ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
    : true;
}
function ZoneTable(props) {
  const { columns, data } = props;
  const [selectedRows, setSelectedRows] = useState([]);
  
  // const handleHeaderCheckboxChange = (e) => {
  //   const isChecked = e.target.checked;
  //   const updatedSelectedRows = data.map((row) => ({
  //     ...row,
  //     isSelected: isChecked
  //   }));
  //   setSelectedRows(isChecked ? updatedSelectedRows : []);
  //   props.checkBoxData(selectedRows);
  //   console.log("checked",isChecked)
  // };

  // const handleHeaderCheckboxChange = (e) => {
    
  //   setSelectedRows(e.target.checked ? data : []);
  //   // props.checkBoxData(selectedRows);
  // };
  const handleRowCheckboxChange = (row) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.some((selectedRow) =>
        Object.is(selectedRow, row.original)
      );

      if (isSelected) {
        return prevSelectedRows.filter(
          (selectedRow) => !Object.is(selectedRow, row.original)
        );
      } else {
        return [...prevSelectedRows, row.original];
      }
    });
    props.checkBoxData(selectedRows);
  };
  useEffect(() => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.filter(
        (selectedRow) =>
          !props.deletedAssets.some((deletedAsset) =>
            Object.is(selectedRow, deletedAsset)
          )
      )
    );
  }, [props.deletedAssets]);

  useEffect(() => {
    
    props.checkBoxData !=undefined && props.checkBoxData(selectedRows);
  }, [selectedRows]);

  return (
    <Styles>
      <Table
        totalCount={props.totalCount}
        columns={props.columns}
        data={props.data}
        pagination={props?.noPaging ? "" : !props.pagination}
        scroll={props.scroll}
        scrollRef={props.scrollRef}
        defaultFilterMethod={(filter, row) =>
          filterCaseInsensitive(filter, row)
        }
        paginationDoubleScreen={props.paginationDoubleScreen}
        activepageCount={props.activepageCount}
        paginationCountHanlde={props.paginationCountHanlde}
        invoiceStyle={true}
        tigger={props?.tigger}
        // table={props.table}
        tabTemp={props?.tabTemp}
        userfilterAction={props.userfilterAction}
        tempBtnType={props.tempBtnType}
        // tempKey={
        //   props.tempKey == forceNav ? forceNav + uuidv4() : props.tempKey
        // }
        checkBox={props.isCheckBox}
        onRowCheckboxChange={handleRowCheckboxChange}
        // onHeaderCheckboxChange={handleHeaderCheckboxChange}
      />
    </Styles>
  );
}

export default ZoneTable;
